export const addUrlProtocol = (url: string) => {
  if (!url) {
    return ''
  }

  return /^https?:\/\//.test(url) ? url : `https://${url}`
}
